// ============================================================================
// PairsForm — Géographie française : département et région depuis un code
// postal (lot N des retours bêta, annuaire des alumni, FX 2026-10-28)
// ============================================================================
// UNE SEULE table départements → régions, consommée par la recherche de
// sous-traitants (fiche alumni : code postal saisi, département et région
// DÉRIVÉS à la lecture, jamais stockés) et réutilisable par toute fiche qui
// porte un code postal (animateurs, stagiaires). Régions de 2016 ; les
// départements et collectivités d'outre-mer portent leur propre nom. Un code
// postal Cedex donne le département du centre de tri, en pratique celui de
// l'employeur.
// ============================================================================
const ARA = "Auvergne-Rhône-Alpes";
const BFC = "Bourgogne-Franche-Comté";
const BRE = "Bretagne";
const CVL = "Centre-Val de Loire";
const COR = "Corse";
const GES = "Grand Est";
const HDF = "Hauts-de-France";
const IDF = "Île-de-France";
const NOR = "Normandie";
const NAQ = "Nouvelle-Aquitaine";
const OCC = "Occitanie";
const PDL = "Pays de la Loire";
const PAC = "Provence-Alpes-Côte d'Azur";
const OM = "Outre-mer";
export const DEPARTEMENTS = [
    { code: "01", nom: "Ain", region: ARA },
    { code: "02", nom: "Aisne", region: HDF },
    { code: "03", nom: "Allier", region: ARA },
    { code: "04", nom: "Alpes-de-Haute-Provence", region: PAC },
    { code: "05", nom: "Hautes-Alpes", region: PAC },
    { code: "06", nom: "Alpes-Maritimes", region: PAC },
    { code: "07", nom: "Ardèche", region: ARA },
    { code: "08", nom: "Ardennes", region: GES },
    { code: "09", nom: "Ariège", region: OCC },
    { code: "10", nom: "Aube", region: GES },
    { code: "11", nom: "Aude", region: OCC },
    { code: "12", nom: "Aveyron", region: OCC },
    { code: "13", nom: "Bouches-du-Rhône", region: PAC },
    { code: "14", nom: "Calvados", region: NOR },
    { code: "15", nom: "Cantal", region: ARA },
    { code: "16", nom: "Charente", region: NAQ },
    { code: "17", nom: "Charente-Maritime", region: NAQ },
    { code: "18", nom: "Cher", region: CVL },
    { code: "19", nom: "Corrèze", region: NAQ },
    { code: "2A", nom: "Corse-du-Sud", region: COR },
    { code: "2B", nom: "Haute-Corse", region: COR },
    { code: "21", nom: "Côte-d'Or", region: BFC },
    { code: "22", nom: "Côtes-d'Armor", region: BRE },
    { code: "23", nom: "Creuse", region: NAQ },
    { code: "24", nom: "Dordogne", region: NAQ },
    { code: "25", nom: "Doubs", region: BFC },
    { code: "26", nom: "Drôme", region: ARA },
    { code: "27", nom: "Eure", region: NOR },
    { code: "28", nom: "Eure-et-Loir", region: CVL },
    { code: "29", nom: "Finistère", region: BRE },
    { code: "30", nom: "Gard", region: OCC },
    { code: "31", nom: "Haute-Garonne", region: OCC },
    { code: "32", nom: "Gers", region: OCC },
    { code: "33", nom: "Gironde", region: NAQ },
    { code: "34", nom: "Hérault", region: OCC },
    { code: "35", nom: "Ille-et-Vilaine", region: BRE },
    { code: "36", nom: "Indre", region: CVL },
    { code: "37", nom: "Indre-et-Loire", region: CVL },
    { code: "38", nom: "Isère", region: ARA },
    { code: "39", nom: "Jura", region: BFC },
    { code: "40", nom: "Landes", region: NAQ },
    { code: "41", nom: "Loir-et-Cher", region: CVL },
    { code: "42", nom: "Loire", region: ARA },
    { code: "43", nom: "Haute-Loire", region: ARA },
    { code: "44", nom: "Loire-Atlantique", region: PDL },
    { code: "45", nom: "Loiret", region: CVL },
    { code: "46", nom: "Lot", region: OCC },
    { code: "47", nom: "Lot-et-Garonne", region: NAQ },
    { code: "48", nom: "Lozère", region: OCC },
    { code: "49", nom: "Maine-et-Loire", region: PDL },
    { code: "50", nom: "Manche", region: NOR },
    { code: "51", nom: "Marne", region: GES },
    { code: "52", nom: "Haute-Marne", region: GES },
    { code: "53", nom: "Mayenne", region: PDL },
    { code: "54", nom: "Meurthe-et-Moselle", region: GES },
    { code: "55", nom: "Meuse", region: GES },
    { code: "56", nom: "Morbihan", region: BRE },
    { code: "57", nom: "Moselle", region: GES },
    { code: "58", nom: "Nièvre", region: BFC },
    { code: "59", nom: "Nord", region: HDF },
    { code: "60", nom: "Oise", region: HDF },
    { code: "61", nom: "Orne", region: NOR },
    { code: "62", nom: "Pas-de-Calais", region: HDF },
    { code: "63", nom: "Puy-de-Dôme", region: ARA },
    { code: "64", nom: "Pyrénées-Atlantiques", region: NAQ },
    { code: "65", nom: "Hautes-Pyrénées", region: OCC },
    { code: "66", nom: "Pyrénées-Orientales", region: OCC },
    { code: "67", nom: "Bas-Rhin", region: GES },
    { code: "68", nom: "Haut-Rhin", region: GES },
    { code: "69", nom: "Rhône", region: ARA },
    { code: "70", nom: "Haute-Saône", region: BFC },
    { code: "71", nom: "Saône-et-Loire", region: BFC },
    { code: "72", nom: "Sarthe", region: PDL },
    { code: "73", nom: "Savoie", region: ARA },
    { code: "74", nom: "Haute-Savoie", region: ARA },
    { code: "75", nom: "Paris", region: IDF },
    { code: "76", nom: "Seine-Maritime", region: NOR },
    { code: "77", nom: "Seine-et-Marne", region: IDF },
    { code: "78", nom: "Yvelines", region: IDF },
    { code: "79", nom: "Deux-Sèvres", region: NAQ },
    { code: "80", nom: "Somme", region: HDF },
    { code: "81", nom: "Tarn", region: OCC },
    { code: "82", nom: "Tarn-et-Garonne", region: OCC },
    { code: "83", nom: "Var", region: PAC },
    { code: "84", nom: "Vaucluse", region: PAC },
    { code: "85", nom: "Vendée", region: PDL },
    { code: "86", nom: "Vienne", region: NAQ },
    { code: "87", nom: "Haute-Vienne", region: NAQ },
    { code: "88", nom: "Vosges", region: GES },
    { code: "89", nom: "Yonne", region: BFC },
    { code: "90", nom: "Territoire de Belfort", region: BFC },
    { code: "91", nom: "Essonne", region: IDF },
    { code: "92", nom: "Hauts-de-Seine", region: IDF },
    { code: "93", nom: "Seine-Saint-Denis", region: IDF },
    { code: "94", nom: "Val-de-Marne", region: IDF },
    { code: "95", nom: "Val-d'Oise", region: IDF },
    { code: "971", nom: "Guadeloupe", region: OM },
    { code: "972", nom: "Martinique", region: OM },
    { code: "973", nom: "Guyane", region: OM },
    { code: "974", nom: "La Réunion", region: OM },
    { code: "975", nom: "Saint-Pierre-et-Miquelon", region: OM },
    { code: "976", nom: "Mayotte", region: OM },
    { code: "977", nom: "Saint-Barthélemy", region: OM },
    { code: "978", nom: "Saint-Martin", region: OM },
    { code: "986", nom: "Wallis-et-Futuna", region: OM },
    { code: "987", nom: "Polynésie française", region: OM },
    { code: "988", nom: "Nouvelle-Calédonie", region: OM },
];
/** Les régions, dans l'ordre d'affichage d'un sélecteur (Outre-mer en dernier). */
export const REGIONS = [
    ARA, BFC, BRE, CVL, COR, GES, HDF, IDF, NOR, NAQ, OCC, PDL, PAC, OM,
];
const PAR_CODE = new Map(DEPARTEMENTS.map((d) => [d.code, d]));
/**
 * Code postal normalisé sur 5 chiffres (espaces rognés ; un code à 4 chiffres
 * récupère le zéro initial qu'Excel a mangé : « 6000 » → « 06000 »).
 * null si la valeur n'est pas un code postal.
 */
export function normaliserCodePostal(valeur) {
    if (valeur === null || valeur === undefined)
        return null;
    const s = String(valeur).replace(/\s+/g, "");
    if (/^\d{5}$/.test(s))
        return s;
    if (/^\d{4}$/.test(s))
        return `0${s}`;
    return null;
}
/** Code du département porté par un code postal (« 2A » / « 2B » pour la Corse,
 *  trois chiffres outre-mer), null si inconnu. */
export function departementDepuisCodePostal(codePostal) {
    const cp = normaliserCodePostal(codePostal);
    if (!cp)
        return null;
    if (cp.startsWith("20")) {
        // Corse : 200xx-201xx = Corse-du-Sud, 202xx et au-delà = Haute-Corse.
        return Number(cp) < 20200 ? "2A" : "2B";
    }
    if (cp.startsWith("97") || cp.startsWith("98")) {
        const code = cp.slice(0, 3);
        return PAR_CODE.has(code) ? code : null;
    }
    const code = cp.slice(0, 2);
    return PAR_CODE.has(code) ? code : null;
}
export function departementParCode(code) {
    return code ? (PAR_CODE.get(code) ?? null) : null;
}
/** « 93 Seine-Saint-Denis » — libellé d'affichage d'un département. */
export function libelleDepartement(code) {
    const d = departementParCode(code);
    return d ? `${d.code} ${d.nom}` : null;
}
export function regionDepuisDepartement(code) {
    return departementParCode(code)?.region ?? null;
}
export function regionDepuisCodePostal(codePostal) {
    return regionDepuisDepartement(departementDepuisCodePostal(codePostal));
}
/** Les départements d'une région, dans l'ordre des codes. */
export function departementsDeLaRegion(region) {
    return DEPARTEMENTS.filter((d) => d.region === region);
}
//# sourceMappingURL=geo.js.map